import type { AppNavGroup, AppUser } from "@/config/appNav";
import { SUPER_ADMIN_USER } from "@/pages/super-admin/data/types";

export const SUPER_ADMIN_NAV_GROUPS: AppNavGroup[] = [
  {
    items: [{ label: "Tableau de bord", to: "/super-admin", icon: "ri-dashboard-3-line" }],
  },
  {
    title: "Utilisateurs",
    items: [
      { label: "Inscriptions en attente", to: "/super-admin/inscriptions", icon: "ri-user-received-2-line" },
      { label: "Utilisateurs", to: "/super-admin/utilisateurs", icon: "ri-user-settings-line" },
      { label: "Propriétaires", to: "/super-admin/proprietaires", icon: "ri-user-star-line" },
      { label: "Agences", to: "/super-admin/agences", icon: "ri-building-2-line" },
      { label: "Administrateurs", to: "/super-admin/administrateurs", icon: "ri-admin-line" },
    ],
  },
  {
    title: "Patrimoine",
    items: [
      { label: "Immeubles", to: "/super-admin/immeubles", icon: "ri-building-2-line" },
      { label: "Biens", to: "/super-admin/biens", icon: "ri-home-4-line" },
      { label: "Locataires", to: "/super-admin/locataires", icon: "ri-user-3-line" },
      { label: "Contrats", to: "/super-admin/contrats", icon: "ri-file-text-line" },
    ],
  },
  {
    title: "Abonnements",
    items: [
      { label: "Formules", to: "/super-admin/formules", icon: "ri-vip-diamond-line" },
      { label: "Essais gratuits", to: "/super-admin/essais", icon: "ri-gift-2-line" },
      { label: "Abonnements", to: "/super-admin/abonnements", icon: "ri-repeat-2-line" },
      { label: "Paiements", to: "/super-admin/paiements", icon: "ri-hand-coin-line" },
    ],
  },
  {
    title: "Territoire",
    items: [
      { label: "Régions", to: "/super-admin/regions", icon: "ri-map-2-line" },
      { label: "Provinces", to: "/super-admin/provinces", icon: "ri-community-line" },
      { label: "Communes / Villes", to: "/super-admin/communes", icon: "ri-map-pin-2-line" },
      { label: "Secteurs / Quartiers", to: "/super-admin/secteurs", icon: "ri-road-map-line" },
    ],
  },
  {
    title: "Analyse",
    items: [
      { label: "Statistiques", to: "/super-admin/statistiques", icon: "ri-bar-chart-box-line" },
      { label: "Rapports", to: "/super-admin/rapports", icon: "ri-file-chart-line" },
      { label: "Journal d'audit", to: "/super-admin/audit", icon: "ri-shield-check-line" },
    ],
  },
  {
    title: "Configuration",
    items: [{ label: "Paramètres", to: "/super-admin/parametres", icon: "ri-settings-3-line" }],
  },
];

export const SUPER_ADMIN_APP_USER: AppUser = {
  name: SUPER_ADMIN_USER.name,
  role: SUPER_ADMIN_USER.role,
  initials: SUPER_ADMIN_USER.initials,
};